import { render, staticRenderFns } from "./PrivateChat.vue?vue&type=template&id=11ccc736&lang=pug&"
import script from "./PrivateChat.vue?vue&type=script&lang=ts&"
export * from "./PrivateChat.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports